/* globals canManageGeneralRisks */
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

export default function GeneralIssue(props) {
    const [isLoading, setIsLoading] = useState(true);
    const [issue, setIssue] = useState(null);

    useEffect(() => {
        fetchDataset();
    }, []);

    const fetchDataset = () => {
        setIsLoading(true);
        axios
            .get(fetchGeneralIssueUrl)
            .then(({ data }) => {
                setIssue(data);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => setIsLoading(false));
    };
    if (isLoading) {
        return <Loading />;
    } else if (!issue) {
        return <div className="text-danger">{$t('Something went wrong')}.</div>;
    }

    return (
        <div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="card-title">{$t('General Issue')}</h5>
                    <div className="row">
                        <div className="col-6">
                            <table className="table table-borderless no-footer">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Description')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{issue.description}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Detailed description')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{issue.detailed_description}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Owner')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">
                                            {issue.owner?.first_name} {issue.owner?.last_name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Decision maker')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{issue.decision_maker}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Outcome')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{issue.outcome}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Status')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{issue.status?.title}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Priority')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{issue.priority}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0 tw-capitalize">
                                            {$t('Resolution date')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{issue.resolution_date}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-6">
                            <table className="table table-borderless no-footer">
                                <tbody>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('No. of Actions')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{issue.actions_count.total}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Actions - Completed')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{issue.actions_count.completed}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '30%' }} className="p-0">
                                            {$t('Actions - Outstanding')}
                                        </td>
                                        <td className="text-primary font-weight-bold p-1">{issue.actions_count.outstanding}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card bg-white border-0 rounded-15px shadow my-4">
                <div className="card-body">
                    <h5 className="card-title">{$t('Inter-dependencies')}</h5>
                    {!issue.risks?.length && !issue.decisions?.length ? (
                        <div>{$t('No Inter-dependencies')}</div>
                    ) : (
                        <table className="table table-sm table-bordered no-footer text-center m-0">
                            <thead>
                                <tr className="text-center font-weight-bold text-blue table__label_text">
                                    <th style={{ width: '10%' }}>{$t('Unique Reference')}</th>
                                    <th style={{ minWidth: '200px' }}>{$t('Description')}</th>
                                    <th>{$t('Type')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {issue.risks.map((risk) => (
                                    <InterDependencyRow
                                        row={risk}
                                        link={canManageGeneralRisks ? fetchGeneralRiskUrl.replace('GENERAL_RISK_ID', risk.id) : null}
                                        key={risk.id}
                                        type={$t('General Risk')}
                                    />
                                ))}
                                {issue.decisions.map((decision) => (
                                    <InterDependencyRow
                                        row={decision}
                                        link={fetchGeneralDecisionUrl.replace('GENERAL_DECISION_ID', decision.id)}
                                        key={decision.id}
                                        type={$t('General Decision')}
                                    />
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

function Loading() {
    return (
        <div className="row my-2">
            <div className="col-12 d-flex align-items-center justify-content-center text-blue">
                <div
                    className="spinner-border"
                    style={{
                        width: '2rem',
                        height: '2rem',
                    }}
                    role="status"
                >
                    <span className="sr-only">{$t('Loading')}...</span>
                </div>
            </div>
        </div>
    );
}

/**
 * One related record in the Inter-dependencies table.
 *
 * A NULL `link` RENDERS THE DESCRIPTION AS TEXT, not as a dead anchor. The
 * related record's own page can refuse this user — `general-risks.show` is
 * gated on manage-general-risk, which is assignable independently of the
 * permission that got them onto this page — so the row still names the
 * dependency and simply does not pretend it can be opened. An `<a>` with no
 * href looks clickable and is not; one that 403s is worse.
 */
function InterDependencyRow({ row, link, type }) {
    return (
        <tr>
            <td>{row.id}</td>
            <td className="text-left">{link ? <a href={link}>{row.description}</a> : row.description}</td>
            <td>{type}</td>
        </tr>
    );
}

if (document.getElementById('generalIssueShow')) {
    var root = document.getElementById('generalIssueShow');
    ReactDOM.render(
        <App>
            <GeneralIssue />
        </App>,
        root,
    );
}
